define('plugin/google-translate/model/GoogleTranslateModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Gallery data model
     *
     * @class GoogleTranslateModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/google-translate/item/id/',

        defaults: {
            id: '',
            langs: null,
            mode: 'vertical',
            base_lang: 'en',
        }
    });

});
